import { render, staticRenderFns } from "./mb-fotter.vue?vue&type=template&id=1985a836&scoped=true&"
import script from "./mb-fotter.vue?vue&type=script&lang=js&"
export * from "./mb-fotter.vue?vue&type=script&lang=js&"
import style0 from "./mb-fotter.vue?vue&type=style&index=0&id=1985a836&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1985a836",
  null
  
)

export default component.exports